import { createReducer, createActions } from "reduxsauce";
import update from "immutability-helper";
import { IState, ISuccessAction, IFailureAction } from "interfaces/create-duck";

const { Types, Creators } = createActions(
  {
    request: ["postData", "onSuccess", "onFailure"],
    success: ['data'],
    failure: ["error"],
    reset: [],
  },
  { prefix: "UPLOAD_DELIVERY_RECEIPT_SCHEDULING_FOB_" }
);

export interface UploadDeliveryReceiptSchedulingFOBState extends IState {
  data: [];
}

export interface UploadDeliveryReceiptSchedulingFOBSuccess extends ISuccessAction {
  data: [];
}

const INITIAL_STATE: UploadDeliveryReceiptSchedulingFOBState = {
  data: [],
  loading: false,
  error: null,
};

const request = (state: UploadDeliveryReceiptSchedulingFOBState) =>
  update(state, {
    loading: { $set: true },
    error: { $set: null },
  });

const success = (
  state: UploadDeliveryReceiptSchedulingFOBState,
  action: UploadDeliveryReceiptSchedulingFOBSuccess
) =>
  update(state, {
    data: { $set: action.data },
    loading: { $set: false },
  });

const failure = (state: UploadDeliveryReceiptSchedulingFOBState, action: IFailureAction) =>
  update(state, {
	data: { $set: []},
    loading: { $set: false },
    error: { $set: action.error },
  });

const reset = () => INITIAL_STATE;

export const uploadDeliveryReceiptSchedulingFOB = createReducer(INITIAL_STATE, {
  [Types.REQUEST]: request,
  [Types.SUCCESS]: success,
  [Types.FAILURE]: failure,
  [Types.RESET]: reset,
});

export const UploadDeliveryReceiptSchedulingFOBTypes = Types;
export const UploadDeliveryReceiptSchedulingFOBActions = Creators;
